import Vue from 'vue';
import fvWidth from "./fvWidth"
import fvWindowOpen from "./fvWindowOpen"
import fvBoolInput from "./fvBoolInput"
import fvColorTransform from "./fvColorTransform"
import fvContextMenu from "./fvContextMenu"
import fvFlow from "./fvFlow"
import fvForbid from "./fvForbid"
import fvGeneralOperation from "./fvGeneralOperation"
import fvHeight from "./fvHeight"
import fvHide from "./fvHide"
import fvHorDrag from "./fvHorDrag"
import fvHorFill from "./fvHorFill"
import fvHorMove from "./fvHorMove"
import fvLineColor from "./fvLineColor"
import fvLmousescript from "./fvLmousescript"
import fvMessage from "./fvMessage"
import fvMousescript from "./fvMousescript"
import fvOutput from "./fvOutput"
import fvOutputChar from "./fvOutputChar"
import fvOutputSwitch from "./fvOutputSwitch"
import fvRmousescript from "./fvRmousescript"
import fvRotateMove from "./fvRotateMove"
import fvStringInput from "./fvStringInput"
import fvTextColor from "./fvTextColor"
import fvTwinkel from "./fvTwinkel"
import fvVarInput from "./fvVarInput"
import fvVerticalDrag from "./fvVerticalDrag"
import fvVerticalFill from "./fvVerticalFill"
import fvVerticalMove from "./fvVerticalMove"
Vue.prototype.fvWidthSvg = fvWidth;
Vue.prototype.fvWindowOpen = fvWindowOpen;
Vue.prototype.fvBoolInputSvg = fvBoolInput;//开关两输入值动画
Vue.prototype.fvColorTransform = fvColorTransform;
Vue.prototype.fvContextMenuSvg = fvContextMenu;//右键菜单动画
Vue.prototype.fvFlowSvg = fvFlow;
Vue.prototype.fvForbidSvg = fvForbid;
Vue.prototype.fvGeneralOperationSvg = fvGeneralOperation;
Vue.prototype.fvHeightSvg = fvHeight;
Vue.prototype.fvHideSvg = fvHide;
Vue.prototype.fvHorDragSvg = fvHorDrag;//水平拖动动画
Vue.prototype.fvHorFill = fvHorFill;
Vue.prototype.fvHorMoveSvg = fvHorMove;//水平移动
Vue.prototype.fvLineColor = fvLineColor;
Vue.prototype.fvLmousescriptSvg = fvLmousescript;//左键动画
Vue.prototype.fvMessageSvg = fvMessage;//信息提示动画
Vue.prototype.fvMousescriptSvg = fvMousescript;//鼠标动作动画
Vue.prototype.fvOutputSvg = fvOutput;//模拟值（数值）
Vue.prototype.fvOutputCharSvg = fvOutputChar;//模拟值（字符串）
Vue.prototype.fvOutputSwitchSvg = fvOutputSwitch;//输入值动画 开关量
Vue.prototype.fvRmousescriptSvg = fvRmousescript;
Vue.prototype.fvRotateMoveSvg = fvRotateMove;//旋转动画
Vue.prototype.fvStringInputSvg = fvStringInput;//输入值动画（字符串）
Vue.prototype.fvTextColor = fvTextColor;
Vue.prototype.fvTwinkel = fvTwinkel;
Vue.prototype.fvVarInputSvg = fvVarInput;//输入值动画
Vue.prototype.fvVerticalDragSvg = fvVerticalDrag;//垂直移动动画
Vue.prototype.fvVerticalFill = fvVerticalFill;
Vue.prototype.fvVerticalMoveSvg = fvVerticalMove;//垂直移动动画
Vue.prototype.fvLineColorSvg = fvLineColor;//颜色（边线动画）
Vue.prototype.fvTextColorSvg=fvTextColor;//颜色（实体文本动画）
Vue.prototype.fvColorTransformSvg=fvColorTransform;//颜色（条件）变化动画
Vue.prototype.fvTwinkelSvg=fvTwinkel;//颜色（闪烁动画）
Vue.prototype.fvVerticalFillSvg=fvVerticalFill;//颜色百分比填充（垂直动画）
Vue.prototype.fvHorFillSvg=fvHorFill;//颜色百分比填充（水平动画）



// WEBPACK FOOTER //
// ./src/js/div/animationDiv/index.js